import type { ContentNode, DocumentState } from '../document-types';
import type { NodeHandler, RenderContext } from './types';

export class BulletListHandler implements NodeHandler {
  readonly type = 'bulletList';

  render(
    _node: ContentNode | DocumentState,
    _parent: ContentNode | DocumentState | null,
    childContent: string,
    _ctx: RenderContext
  ): string {
    return childContent;
  }
}

export class OrderedListHandler implements NodeHandler {
  readonly type = 'orderedList';

  render(
    _node: ContentNode | DocumentState,
    _parent: ContentNode | DocumentState | null,
    childContent: string,
    _ctx: RenderContext
  ): string {
    return childContent;
  }
}

export class ListItemHandler implements NodeHandler {
  readonly type = 'listItem';

  render(
    _node: ContentNode | DocumentState,
    parent: ContentNode | DocumentState | null,
    childContent: string,
    _ctx: RenderContext
  ): string {
    const parentType = parent?.type;
    const content = childContent.trim();

    if (parentType === 'orderedList') {
      return '1. ' + content + '\n';
    }
    return '- ' + content + '\n';
  }
}
